import React, { useState, useEffect } from "react";
import NavBar from "../Components/NavBar";
import ItemEventoUser from "./ItemEventoUser";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../FirebaseConfig/firebase";
import "../CSS/eventos.css";
const MySwal = withReactContent(Swal);

function Eventos() {
  const navigate = useNavigate();
  //configurar useState
  const [eventos, setEventos] = useState([]);
  const [colegiados, setColegiados] = useState([]);
  const [isColegiado, setIsColegiado] = useState(false);
  const [lenEventos, setLenEventos] = useState(0);

  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  //referenciar la DB
  const eventosList = collection(db, "EVENTOS");
  //funcion para mostrar la lista de eventos
  const getEventos = async () => {
    const q = query(collection(db, "EVENTOS"), where("estado", "==", "Activo"));
    const querySnapshot = await getDocs(q);
    setEventos(
      querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    );
    setDatosCargados(true);
  };

  const getColegiados = async () => {
    const q = query(collection(db, "COLEGIADOS"));
    const querySnapshot = await getDocs(q);
    setColegiados(
      querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    );
  };
  //cerrar eventos
  const cerrar = () => {
    navigate("../panelUser");
  };
  //uso de useEffect
  useEffect(() => {
    getEventos();
    getColegiados();
    console.log("len " + lenEventos);
  }, []);
  
  useEffect(() => {
    //console.log(localStorage.getItem("idLocal"))
    colegiados.map((item, index) => {
      if (localStorage.getItem("idLocal") == item.cip) {
        setIsColegiado(true);
        //console.log("si es colegiado")
      }
      //console.log(localStorage.getItem("idLocal"))
      //console.log("la respuesta es" + item.cip)
    });
  }, [colegiados]);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`../img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="eventos">
      <NavBar
        titulo="Eventos"
        imagen="cerrar"
        logoTitulo="eventos"
        cerrar={cerrar}
      ></NavBar>
      {eventos.length == 0 ? (
        <div>
          <p style={{ marginTop: "50px", textAlign: "center" }}>
            No hay eventos activos
          </p>
        </div>
      ) : null}
      <div className="eventos-grid-container">
        {eventos.map((item) => {
          if (item.tipoEvento == "Colegiatura") {
            if (isColegiado) {
              return (
                <div className="eventos-element">
                  <ItemEventoUser
                    nombre={item.nombre}
                    fecha={item.fecha}
                    descripcion={item.descripcion}
                    id={item.id}
                    imagen={item.urlImagen}
                  />
                </div>
              );
            }
          } else {
            return (
              <div className="eventos-element">
                <ItemEventoUser
                  nombre={item.nombre}
                  fecha={item.fecha}
                  descripcion={item.descripcion}
                  id={item.id}
                  imagen={item.urlImagen}
                  salon={item.salon}
                />
              </div>
            );
          }
        })}
      </div>
    </div>
  );
}
export default Eventos;
